export const FETCH_FAQS_REQUEST = 'FETCH_FAQS_REQUEST'
export const FETCH_FAQS_SUCCESS = 'FETCH_FAQS_SUCCESS'
export const FETCH_FAQS_FAILURE = 'FETCH_FAQS_FAILURE'